var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 78,
    height: 78,
    rx: 39,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 24V26.5H36.5V24H24V57.75H54V24H41.5Z",
    fill: "#E5EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6675 38.605C41.4248 38.2288 42.0327 37.6076 42.3926 36.8425C42.7524 36.0773 42.8431 35.2129 42.6499 34.3897C42.4567 33.5665 41.9909 32.8327 41.3282 32.3075C40.6654 31.7824 39.8447 31.4966 38.9991 31.4966C38.1535 31.4966 37.3327 31.7824 36.67 32.3075C36.0073 32.8327 35.5415 33.5665 35.3483 34.3897C35.1551 35.2129 35.2458 36.0773 35.6056 36.8425C35.9655 37.6076 36.5734 38.2288 37.3307 38.605C36.0005 38.9455 34.8244 39.7254 33.993 40.8181C33.1616 41.9107 32.7236 43.2522 32.75 44.625H45.25C45.2761 43.252 44.8378 41.9105 44.006 40.8178C43.1743 39.7251 41.9979 38.9454 40.6675 38.605Z",
    fill: "#6186FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 49.625H31.5C31.3342 49.625 31.1753 49.5592 31.0581 49.4419C30.9408 49.3247 30.875 49.1658 30.875 49C30.875 48.8342 30.9408 48.6753 31.0581 48.5581C31.1753 48.4408 31.3342 48.375 31.5 48.375H46.5C46.6658 48.375 46.8247 48.4408 46.9419 48.5581C47.0592 48.6753 47.125 48.8342 47.125 49C47.125 49.1658 47.0592 49.3247 46.9419 49.4419C46.8247 49.5592 46.6658 49.625 46.5 49.625ZM42.75 53.375H35.25C35.0842 53.375 34.9253 53.3092 34.8081 53.1919C34.6908 53.0747 34.625 52.9158 34.625 52.75C34.625 52.5842 34.6908 52.4253 34.8081 52.3081C34.9253 52.1908 35.0842 52.125 35.25 52.125H42.75C42.9158 52.125 43.0747 52.1908 43.1919 52.3081C43.3092 52.4253 43.375 52.5842 43.375 52.75C43.375 52.9158 43.3092 53.0747 43.1919 53.1919C43.0747 53.3092 42.9158 53.375 42.75 53.375Z",
    fill: "#7B8BAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M35.2494 27.7494V23.9994L40.2494 24L41.5 26.4994L40.2494 27.75L35.2494 27.7494Z",
    fill: "#000064"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 20.25H41.5V26.4988H36.5V20.25Z",
    fill: "#7C9DF2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M39 31.5C38.1557 31.5016 37.3366 31.7881 36.6754 32.3131C36.0141 32.8381 35.5494 33.5709 35.3564 34.3929C35.1634 35.2148 35.2535 36.0779 35.612 36.8423C35.9705 37.6067 36.5765 38.2278 37.3319 38.605C36.0015 38.9453 34.8252 39.7251 33.9935 40.8178C33.1618 41.9105 32.7237 43.2521 32.75 44.625H39V31.5Z",
    fill: "#000064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.bd0dbbfa6366c39734f658ff8744a471.svg";
export { ForwardRef as ReactComponent };